import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EntityCrudService } from '@data/entity-crud.service';
import { IStopInput, Stop } from './stop.model';

/**
 * CRUD for the anymatch Stop against the pin-guarded public routes:
 *   GET  /public/stops/:id           → getById(id, params, true)
 *   POST /public/stops               → create(input, true)   (session in body)
 *   PUT  /public/stops/:id           → update(id, changes, true)
 *
 * The `X-Session-Id` / `X-Session-Pin` headers are attached by SessionPinInterceptor.
 */
@Injectable({ providedIn: 'root' })
export class StopService extends EntityCrudService<IStopInput, Stop> {
  constructor(http: HttpClient) {
    super('stops', http, 'stops');
  }

  /**
   * Email the exhibitor a pin-embedded edit link for their Stop (`/public/stop?...&pin=`).
   *
   * `URL_PUBLIC` already ends in `/public/stops` — the extra `/stops` this used to prepend
   * produced `/public/stops/stops/:id/mail-edit`, which no route matches, so every edit mail
   * 404'd instead of being sent.
   */
  sendEditLink(stopId: string, email: string) {
    return this.http.post(`${this.URL_PUBLIC}/${stopId}/mail-edit`, { email });
  }

  /** Organizer (team-guarded): email an exhibitor their Stop edit link. */
  sendEditLinkInternal(stopId: string, email: string) {
    return this.http.post(`${this.URL_PRIVATE}/${stopId}/mail-edit`, { email });
  }

  /** Organizer: list a session's Stops (private, team-guarded). */
  listForSession(sessionId: string): Observable<Stop[]> {
    return this.http.get<Stop[]>(`${this.URL_PRIVATE}/session/${sessionId}`);
  }
}
